import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useQuery, useQueryClient } from "@tanstack/react-query";

import { useMutationWithError } from "@/hooks";
import { adminApi } from "@/lib/api";

import { type AdminNewsSettings } from "../types";

export const newsSettings = createQueryKeys("admin-news-settings", {
  all: null,
});

export const fetchNewsSettingsQueryOptions = () =>
  queryOptions({
    ...newsSettings.all,
    queryFn: () =>
      adminApi
        .get<AdminNewsSettings>(`/news/settings`)
        .then((response) => response.data),
  });

export const useFetchNewsSettings = () =>
  useQuery(fetchNewsSettingsQueryOptions());

export const useUpdateNewsSettings = () => {
  const queryClient = useQueryClient();

  return useMutationWithError({
    mutationFn: (data: AdminNewsSettings) =>
      adminApi.put(`/news/settings`, data).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [newsSettings.all] });
    },
  });
};
